import React, { useState, useEffect } from 'react';

import { StatusesCheckboxesPopover, StreamIdsSelectPopover, GroupsSelectPopover } from '@vlabs/shared/components/filters-panel';
import { Control, Group, useWindowSize } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectAnalyticData } from '@vlabs/pages/video-analytics/selectors';

import { setFilterCounts } from '../../../store';
import { defaultFilters } from './defaultFilters';
import st from './FilterForm.module.sass';

function FilterForm({ analyticStreamOptions = [], availableGroupsOptions = [], setFilterCountsState }) {
  const { t } = useTranslation();
  const { reset, setFilters } = useFormContext();

  const windowSize = useWindowSize();

  const [counts, setCounts] = useState({});
  const handleCountChange = (key, count) => {
    setCounts((prev) => {
      if (prev[key] === count) return prev;
      return { ...prev, [key]: count };
    });
  };

  useEffect(() => {
    const totalCount = Object.values(counts).reduce((acc, n) => acc + (n || 0), 0);
    setFilterCountsState(totalCount);
  }, [counts, setFilterCountsState]);

  const resetFilters = () => {
    reset(defaultFilters);
    setFilters({});
  };

  return (
    <div className={st.FiltersRoot}>
      <Group gapSize="0" vertical>

        <StatusesCheckboxesPopover onCountChange={handleCountChange} />
        <div className={st.Divider} />
        <StreamIdsSelectPopover onCountChange={handleCountChange} streamIdsOptions={analyticStreamOptions} />
        <div className={st.Divider} />
        <GroupsSelectPopover availableGroupsOptions={availableGroupsOptions} onCountChange={handleCountChange} />
        <div className={st.Divider} />
      </Group>
      <div className={st.ButtonPanel}>
        <Control.Button
          className={st.Button}
          data-testid="FilterForm.clearButton"
          kind="negative"
          onClick={resetFilters}
          size={windowSize.width < 1920 ? 'small' : 'medium'}
        >
          {t('button.clear')}
        </Control.Button>
      </div>
    </div>
  );
}

export default connect((state) => ({
  analyticStreamOptions: selectAnalyticData(state, 'streamOptions'),
  availableGroupsOptions: selectAnalyticData(state, 'groupOptions'),
}),
(dispatch) => ({
  setFilterCountsState: (count) => dispatch(setFilterCounts(count)),
}))(FilterForm);
